module.exports = __webpack_public_path__ + "img/choice_up_rt.ff315d2a.png";